import { render, staticRenderFns } from "./ScoringRequest.vue?vue&type=template&id=56f5656e&lang=pug&"
import script from "./ScoringRequest.vue?vue&type=script&lang=js&"
export * from "./ScoringRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports